
class length {
    constructor (value, unit) {
        this.set(value, unit)
    }
    set (value, unit) {
        if (unit === 'cm') {
            this.value = value
        } else if (unit === 'm') {
            this.value = value * 100
        } else if (unit === 'in' || unit === 'inch') {
            this.value = value * 2.56
        } else if (unit === 'feet') {
            this.value = value * 30.48
        } else {
            this.value = 0
        }
    }
    to (unit) {
        if (unit === 'cm') {
            return this.value.toFixed(2)
        } else if (unit === 'm') {
            return (this.value / 100).toFixed(2)
        } else if (unit === 'in' || unit === 'inch') {
            return (this.value / 2.56).toFixed(2)
        } else if (unit === 'feet') {
            return (this.value / 30.48).toFixed(2)
        }
    }
}

class mass {
    constructor (value, unit) {
        this.set(value, unit)
    }
    set (value, unit) {
        if (unit === 'g') {
            this.value = value
        } else if (unit === 'kg') {
            this.value = value * 1000
        } else if (unit === 'lb') {
            this.value = value * 453.592
        }
    }
    to (unit) {
        if (unit === 'g') {
            return (this.value).toFixed(2)
        } else if (unit === 'kg') {
            return (this.value / 1000).toFixed(2)
        } else if (unit === 'lb') {
            return (this.value / 453.592).toFixed(2)
        }
    }
}

export default {
    length,
    mass
}

export {
    length,
    mass
}
